import {all} from 'redux-saga/effects';
import WizardLaunchSagas from './WizardLaunchSagas';
import CartSagas from './CartSagas';
import ContactSaga from './ContactSaga';
import UserLoginSaga from './UserSagas';

export default function* rootSaga() {
  yield all([
    WizardLaunchSagas(),
    CartSagas(),
    ContactSaga(),
    UserLoginSaga()
  ]);
}
